export default "/fonts/vendor/mdui/dist/roboto/Roboto-Regular.woff?770a8fca674a3550e241a6de7fa82d8b";